import * as actions from './actions';
import mutations from './mutations';
import state from './state';

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/stats/index.js